import Vue from 'vue';

    import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export const TenantBaseConfig = {
  dev: {
    616667: {
      corpName: $t('a0639b'),
      loginDomain: process.env.VUE_APP_REDIRECT_CASURL,
      favico: 'https://mh.vocust.com/favicon.ico',
    },
  },
  fat: {
    616667: {
      corpName: $t('a0639b'),
      loginDomain: process.env.VUE_APP_REDIRECT_CASURL,
      favico: 'https://mh.vocust.com/favicon.ico',
    },
  },
  prod: {
    105753: {
      corpName: $t('a0639b'),
      loginDomain: 'https://mh.vocust.com',
      favico: 'https://mh.vocust.com/favicon.ico',
    },
  },
}

export default {
  namespaced: true,
  state: {
    corpName: $t('6f1a21'),
    loginDomain: process.env.VUE_APP_REDIRECT_CASURL,
  },
  mutations: {
    SET_INFO_BY_TENANT(state, tenantId) {
      const config = TenantBaseConfig[process.env.VUE_APP_ENV]?.[tenantId]
      const isCEM = getAppBaseConfig().appName === 'hotelcem'
      let title = $t('816815'),
        icon = '/xreports/fav.ico'
      if (config) {
        state.corpName = config.corpName
        state.loginDomain = config.loginDomain
        title = config.corpName
        icon = config.favico
      } else {
        const manifest = document.createElement('link')
        manifest.setAttribute('rel', 'manifest')
        manifest.setAttribute('href', `${process.env.VUE_APP_CDN_DOMAIN}/xreports/manifest.json`)
        document.head.appendChild(manifest)

        // 给CEM页面追加ICON
        if (isCEM) {
          const iconUrlList = [
            {
              sizes: '32x32',
              href: `${process.env.VUE_APP_CDNBASEURL}/img/icons/favicon-32x32.png`,
              rel: 'icon',
              type: 'image/png',
            },
            {
              sizes: '16x16',
              href: `${process.env.VUE_APP_CDNBASEURL}/img/icons/favicon-16x16.png`,
              rel: 'icon',
              type: 'image/png',
            },
            {
              href: `${process.env.VUE_APP_CDNBASEURL}/img/icons/apple-touch-icon-152x152.png`,
              rel: 'apple-touch-icon',
            },
          ]
          for (const icon of iconUrlList) {
            const link = document.createElement('link')
            for (const key in icon) {
              link.setAttribute(key, icon[key])
            }
            document.head.appendChild(link)
          }
        }
      }
      const link = document.createElement('link')
      link.setAttribute('rel', 'icon')
      link.setAttribute('href', icon)
      document.head.appendChild(link)
      // 只有cem才改标题
      if (isCEM) {
        document.title = title
      }
    },
  },
}
